export const getAdPreviewStyles = () => ({
  placementContainer: {
    width: '212px',
    height: '236px',
  },
  placementCardHeader: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '12px',
    flexDirection: 'column', // Stack company name and promote text vertically
    alignItems: 'center', // Align to the start of the flex container
    '--fui-CardHeader--gap': '8px  !important',
  },
  placementLogo: {
    width: '24px',
    height: '24px',
  },
  placementCompanyName: {
    color: '#323130',
    fontFamily: 'Segoe UI',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
  },
  placementPromoteText: {
    fontSize: '10px !important',
    color: '#323130',
    lineHeight: '12px !important',
  },

  placementIntroductory: {
    width: '100%',
    height: 38,
    padding: '8px',
  },
  placementIntroductoryText: {
    padding: '0px',
    margin: '0px',
    fontSize: '10px !important',
    lineHeight: '12px !important',
    display: '-webkit-box !important',
  },

  placementCardPreview: {
    width: '212px',
    height: '120px',
  },

  placementCardFooter: {
    height: 38,
    display: 'flex',
    borderWidth: '1px',
    justifyContent: 'space-between',
    background: '#ECF1F6',
  },
  placementFooterText: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '6px',
  },
  placementHeadline: {
    overflow: 'hidden !important',
    display: '-webkit-box !important',
    WebkitBoxOrient: 'vertical !important',
    WebkitLineClamp: '2 !important',
    fontSize: '10px !important',
    fontWeight: '600 !important',
    color: '#323130 !important',
    lineHeight: '12px !important',
    height: '14px',
  },
  placementFinalUrl: {
    border: '0px',
    display: 'block !important',
    fontSize: '10px !important',
    color: '#323130',
    lineHeight: '12px !important',
  },
});
